import React from 'react';

import { retry, put, all } from 'redux-saga/effects';
import qs from 'qs';

import { toast } from 'react-toastify';

import { Creators as ContratanteActions } from '../ducks/contratante';

import { contratantesAPI } from '../../services/api';
import {
  responseHandlerGet,
  responseHandler,
} from '../../utils/responseHandler';

import { ErrorToast } from '../../components/molecules/Toast';
import { toJsonFromBase64 } from '../../utils/array';

export function* getGrupoComplementos(action) {
  const { params } = action.payload;
  const queryString = {
    ...params,
  };

  try {
    const response = yield retry(
      2,
      2000,
      contratantesAPI.get,
      `/parametrizacao-grupo-complemento`,
      {
        params: queryString,
      }
    );

    const { isSuccess } = responseHandlerGet(
      response,
      action.payload,
      'getGrupoComplementos',
      200
    );

    if (isSuccess) {
      const grupoComplementos = {
        ...response.data,
      };

      yield put(
        ContratanteActions.getGrupoComplementosSuccess(
          grupoComplementos,
          isSuccess
        )
      );
    }
  } catch (error) {
    const { unsuccessResponse } = responseHandlerGet(
      error,
      error.data,
      'getGrupoComplementos',
      200
    );

    yield put(
      ContratanteActions.getGrupoComplementosError(unsuccessResponse, error)
    );

    toast.error(
      <ErrorToast size="30">
        Não foi possível realizar a consulta de grupo complemento.
      </ErrorToast>
    );
  }
}

export function* getContratantes(action) {
  const { params } = action.payload;

  const queryString = {
    ...params,
  };

  try {
    const response = yield retry(
      2,
      2000,
      contratantesAPI.get,
      `/parametrizacao-contratante`,
      { params: queryString }
    );

    const { isSuccess } = responseHandlerGet(
      response,
      action.payload,
      'getContratantes',
      200
    );

    if (isSuccess) {
      const contratantes = {
        ...response.data,
      };

      yield put(
        ContratanteActions.getContratanteSuccess(contratantes, isSuccess)
      );
    }
  } catch (error) {
    const { unsuccessResponse } = responseHandlerGet(
      error,
      error.data,
      'getContratantes',
      200
    );

    yield put(ContratanteActions.getContratanteError(unsuccessResponse, error));
  }
}

export function* getGrupoContratantes(action) {
  const { params } = action.payload;

  const queryString = {
    ...params,
  };

  try {
    const response = yield retry(
      2,
      2000,
      contratantesAPI.get,
      `contratante-node`,
      {
        params: queryString,
      }
    );

    const { isSuccess } = responseHandlerGet(
      response,
      action.payload,
      'getGrupoContratantes',
      200
    );

    if (isSuccess) {
      const contratantes = {
        ...response.data,
        id: params.codigoComplemento,
        idCard: params.idCard,
        path: params.path,
        currentPath: params.currentPath,
      };

      yield put(
        ContratanteActions.getGrupoContratantesSuccess(contratantes, isSuccess)
      );
    }
  } catch (error) {
    console.log(error);
    const { unsuccessResponse } = responseHandlerGet(
      error,
      error.data,
      'getGrupoContratantes',
      200
    );

    yield put(
      ContratanteActions.getGrupoContratantesError(
        unsuccessResponse,
        error,
        params.idCard
      )
    );
  }
}

export function* getContratanteModalidades(action) {
  const { params } = action.payload;

  const { path, idCard, ...rest } = params;

  const queryString = {
    ...rest,
  };

  try {
    const response = yield retry(
      2,
      2000,
      contratantesAPI.get,
      `modalidade-node`,
      {
        params: queryString,
      }
    );

    const { isSuccess } = responseHandlerGet(
      response,
      action.payload,
      'getContratanteModalidades',
      200
    );
    if (isSuccess) {
      response.data.modalidadeNode.map((a) => {
        a.codigoContratante = params.codigoContratante;
      });
      const contratantes = {
        ...response.data,
        codigoContratante: params.codigoContratante,
        idCard: params.idCard,
        path: params.path,
        currentPath: params.currentPath,
      };

      yield put(
        ContratanteActions.getContratanteModalidadesSuccess(
          contratantes,
          isSuccess
        )
      );
    }
  } catch (error) {
    const { unsuccessResponse } = responseHandlerGet(
      error,
      error.data,
      'getContratanteModalidades',
      200
    );

    yield put(
      ContratanteActions.getContratanteModalidadesError(
        unsuccessResponse,
        error,
        params.idCard
      )
    );
  }
}

export function* getModalidadeTermos(action) {
  const { params } = action.payload;

  const { idCard, path, ...rest } = params;

  const queryString = {
    ...rest,
  };

  try {
    const response = yield retry(2, 2000, contratantesAPI.get, `termo-node`, {
      params: queryString,
    });

    const { isSuccess } = responseHandlerGet(
      response,
      action.payload,
      'getModalidadeTermos',
      200
    );

    if (isSuccess) {
      const contratantes = {
        ...response.data,
        idCard: params.idCard,
        path: params.path,
        currentPath: params.currentPath,
      };

      yield put(
        ContratanteActions.getModalidadeTermosSuccess(contratantes, isSuccess)
      );
    }
  } catch (error) {
    console.log(error);
    const { unsuccessResponse } = responseHandlerGet(
      error,
      error.data,
      'getModalidadeTermos',
      200
    );

    yield put(
      ContratanteActions.getModalidadeTermosError(
        unsuccessResponse,
        error,
        params.idCard
      )
    );
  }
}

export function* getGrupoContagem(action) {
  const { cards } = action.payload;

  const response = [];

  try {
    yield* cards.map(function* (card) {
      const queryString = {
        codigoGrupo: card.complemento?.codigoGrupo,
        codigoComplemento: card.complemento?.codigoComplemento,
      };

      const resp = yield retry(
        2,
        2000,
        contratantesAPI.get,
        `grupo-totalizador`,
        {
          params: queryString,
        }
      );

      response.push({
        contagem: resp.data,
        idCard: card.idCard,
        status: resp.status,
      });
    });

    const isSuccess = response.every(
      (resp) => resp.status > 199 && resp.status < 299
    );

    if (isSuccess) {
      yield put(
        ContratanteActions.getGrupoContagemSuccess(response, isSuccess, cards)
      );
    }
  } catch (error) {
    console.log(error);
    const { unsuccessResponse } = responseHandlerGet(
      error,
      error.data,
      'getGrupoContagem',
      200
    );

    yield put(
      ContratanteActions.getGrupoContagemError(unsuccessResponse, error, cards)
    );
    toast.error(
      <ErrorToast size="30">
        Não foi possível realizar a consulta de contagem de grupos.
      </ErrorToast>
    );
  }
}

export function* getContratanteContagem(action) {
  const { cards } = action.payload;

  const response = [];

  try {
    yield* cards.map(function* (card) {
      const queryString = {
        codigoContratante: card.contratante?.codigoContratante,
      };

      const resp = yield retry(
        2,
        2000,
        contratantesAPI.get,
        `contratante-totalizador`,
        {
          params: queryString,
        }
      );

      response.push({
        contagem: resp.data,
        idCard: card.idCard,
        status: resp.status,
      });
    });

    const isSuccess = response.every(
      (resp) => resp.status > 199 && resp.status < 299
    );

    if (isSuccess) {
      yield put(
        ContratanteActions.getContratanteContagemSuccess(
          response,
          isSuccess,
          cards
        )
      );
    }
  } catch (error) {
    console.log(error);
    const { unsuccessResponse } = responseHandlerGet(
      error,
      error.data,
      'getContratanteContagem',
      200
    );

    yield put(
      ContratanteActions.getContratanteContagemError(
        unsuccessResponse,
        error,
        cards
      )
    );
    toast.error(
      <ErrorToast size="30">
        Não foi possível realizar a consulta de contagem de contratantes.
      </ErrorToast>
    );
  }
}

export function* getParametrizacaoGrupoComplementoCompleto(action) {
  const { params } = action.payload;

  const queryParams = yield params.map((p) => {
    return {
      codigoGrupo: p.complemento.codigoGrupo,
      codigoComplemento: p.complemento.codigoComplemento,
    };
  });

  try {
    const response = yield all(
      queryParams.map((qp) =>
        retry(
          2,
          2000,
          contratantesAPI.get,
          `parametrizacao-grupo-complemento-completo`,
          { params: qp }
        )
      )
    );
    const isSuccess = response.every((a) => a.status > 199 && a.status < 299);

    if (isSuccess) {
      const newCards = response.map((resp, index) => {
        const treeObject = JSON.parse(
          toJsonFromBase64(resp.data.result.parametrizacao)
        );

        return {
          Tree: treeObject,
          idCard: params[index].idCard,
          contagem: {
            contratantes:
              treeObject.totalizadorParametrizacao.totalContratantes,
            modalidades: treeObject.totalizadorParametrizacao.totalModalidades,
            termos: treeObject.totalizadorParametrizacao.totalTermos,
          },
        };
      });

      yield put(
        ContratanteActions.getParametrizacaoGrupoComplementoCompletoSuccess(
          isSuccess,
          response,
          params
        )
      );
      yield put(
        ContratanteActions.parametrizacaoSetCardsCompletoNewCards(newCards)
      );
    } else {
      throw new Error(
        'Não foi possível realizar a consulta de parametrizações.'
      );
    }
  } catch (error) {
    yield put(
      ContratanteActions.getParametrizacaoGrupoComplementoCompletoError(
        error.message,
        params
      )
    );
    toast.error(
      <ErrorToast size="30">
        Não foi possível realizar a consulta de parametrizações.
      </ErrorToast>
    );
  }
}
export function* getParametrizacaoContratanteCompleto(action) {
  const { params } = action.payload;

  const queryParams = yield params.map((p) => {
    return {
      codigoContratante: p.contratante.codigoContratante,
    };
  });

  try {
    const response = yield all(
      queryParams.map((qp) =>
        retry(
          2,
          2000,
          contratantesAPI.get,
          `parametrizacao-contratante-completo`,
          {
            params: qp,
          }
        )
      )
    );
    const isSuccess = response.every((a) => a.status > 199 && a.status < 299);

    if (isSuccess) {
      const newCards = response.map((resp, index) => {
        const treeObject = JSON.parse(
          toJsonFromBase64(resp.data.result.parametrizacao)
        );

        return {
          Tree: treeObject,
          idCard: params[index].idCard,
          contagem: {
            modalidades: treeObject.totalizadorParametrizacao.totalModalidades,
            termos: treeObject.totalizadorParametrizacao.totalTermos,
          },
        };
      });

      yield put(
        ContratanteActions.getParametrizacaoContratanteCompletoSuccess(
          isSuccess,
          response,
          params
        )
      );
      yield put(
        ContratanteActions.parametrizacaoSetCardsCompletoNewCards(newCards)
      );
    } else {
      throw new Error(
        'Não foi possível realizar a consulta de parametrizações.'
      );
    }
  } catch (error) {
    yield put(
      ContratanteActions.getParametrizacaoContratanteCompletoError(
        error.message,
        params
      )
    );
    toast.error(
      <ErrorToast size="30">
        Não foi possível realizar a consulta de parametrizações.
      </ErrorToast>
    );
  }
}
